export default __webpack_public_path__ + "static/transcribe-case-study-5422e3ec421fe465c40df2eeedebc851.webp";